import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { toast } from "react-toastify";
import "./EditLeague.css"

const API = process.env.REACT_APP_API;

function EditLeague() {
  const { id } = useParams(); // מזהה ליגה מה־URL (אם יש)
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  
  const { token } = useAuth();
  

  const [league, setLeague] = useState({
    code: "",
    name: "",
    rankingFile: "",
    structureFile: "",
    stages: [],
    defaultStageId: null,
  });

  const [newStage, setNewStage] = useState("");

  // טעינת ליגה אם אנחנו במצב עריכה
  useEffect(() => {
    if (id) {
      axios
        .get(`${API}/api/leagues/${id}`)
        .then((res) => {
          setLeague({
            code: res.data.code || "",
            name: res.data.name || "",
            rankingFile: res.data.rankingFile || "",
            structureFile: res.data.structureFile || "",
            stages: res.data.stages || [],
            defaultStageId: res.data.defaultStageId || null,
          });
        })
        .catch(() => toast.error("שגיאה בטעינת הליגה"));
    }
  }, [id]);

  // טיפול בשינויים בשדות
  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeague((prev) => ({ ...prev, [name]: value }));
  };

  // הוספת שלב חדש
  const handleAddStage = () => {
    if (!newStage.trim()) return;
    setLeague((prev) => ({
      ...prev,
      stages: [...prev.stages, { name: newStage }],
    }));
    setNewStage("");
  };

  // מחיקת שלב
  const handleDeleteStage = (index) => {
    setLeague((prev) => ({
      ...prev,
      stages: prev.stages.filter((_, i) => i !== index),
    }));
  };

  // שמירה (יצירה / עדכון)
  const handleSave = async () => {
    setSaving(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("code", league.code);
      formDataToSend.append("name", league.name);
      formDataToSend.append("stages", JSON.stringify(league.stages));
      if (league.defaultStageId) {
        formDataToSend.append("defaultStageId", league.defaultStageId);
      }

      if (league.structureFile instanceof File) {
        formDataToSend.append("structureFile", league.structureFile); // PDF אמיתי
      }

      if (id) {
        await axios.put(`${API}/api/leagues/${id}`, formDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`, // 👈 חובה
          },
        });
        toast.success("הליגה עודכנה בהצלחה");
      } else {
        await axios.post(`${API}/api/leagues`, formDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`, // 👈 חובה
          },
        });
        toast.success("הליגה נוספה בהצלחה");
      }

      navigate("/leagues");
    } catch (err) {
        toast.error("שגיאה בשמירת הליגה");
        console.error(err);
    } finally {
        setSaving(false);
    }
  };

  //עריכה ליגה
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && !["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
      toast.error("אנא בחר תמונה בלבד (JPG או PNG)");
      return;
    }
    setLeague((prev) => ({ ...prev, structureFile: file }));
  };

  // מחיקת ליגה
  const handleDeleteLeague = async () => {
    if (!id) return;
    if (!window.confirm("האם אתה בטוח שברצונך למחוק את הליגה?")) return;

    setDeleting(true);

    try {
      await axios.delete(`${API}/api/leagues/${id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`, // 👈 חובה
        },
      });
      toast.success("הליגה נמחקה בהצלחה");
      navigate("/leagues");
    } catch (err) {
        toast.error("שגיאה במחיקת הליגה");
    } finally {
        setDeleting(false);
    }
  };

  return (
    <div className="edit-league-wrapper">
      <div className="edit-league-container">
        <h2>{id ? "עריכת ליגה" : "הוספת ליגה חדשה"}</h2>

        <div className="form-group">
          <label><strong>קוד ליגה:</strong></label>
          <input
            type="number"
            name="code"
            value={league.code}
            onChange={handleChange}
            placeholder="לדוגמה: 1,2,3..."
          />
        </div>

        <div className="form-group">
          <label><strong>שם ליגה</strong>:</label>
          <input
            type="text"
            name="name"
            value={league.name}
            onChange={handleChange}
            placeholder="לדוגמה: מרכז א"
          />
        </div>

        {league.structureFile && !(league.structureFile instanceof File) && (
        <>
          <label><strong> מבנה הליגה</strong></label>
          <p>
            קובץ קיים:{" "}
            <a
              href={`${league.structureFile}`}
              target="_blank"
              rel="noopener noreferrer"
            >
             צפייה בתמונה
            </a>
          </p>
        </>
        )}

        <div className="form-group">
          <label> קובץ חדש (תמונה):</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange} 
          />
        </div>

        <h3>שלבים</h3>
        <ul className="stages-list">
          {league.stages.map((stage, index) => (
            <li key={index} className="stage-item">
              {/* בחירת ברירת מחדל */}
              {league.stages.length > 1 ? (
              <input
                type="radio"
                name="defaultStage"
                checked={league.defaultStageId === stage._id}
                onChange={() =>
                  setLeague((prev) => ({ ...prev, defaultStageId: stage._id }))
                }
                title="תצוגת ברירת מחדל"
              /> ) : (
              " "
              )}
              <input
                type="text"
                value={stage.name}
                onChange={(e) => {
                  const updatedStages = [...league.stages];
                  updatedStages[index].name = e.target.value;
                  setLeague((prev) => ({ ...prev, stages: updatedStages }));
                }}
                className="stage-input"
              />
              <button
                onClick={() => handleDeleteStage(index)}
                className="delete-stage"
              >
                ❌
              </button>
            </li>
          ))}
        </ul>

        <div className="edit-league-add-stage">
          <input
            type="text"
            value={newStage}
            onChange={(e) => setNewStage(e.target.value)}
            placeholder="שם שלב חדש"
          />
          <button onClick={handleAddStage} className="add-stage-button">➕ הוסף שלב</button>
        </div>

        <div className="buttons">
          <button
            onClick={handleSave}
            disabled={saving || deleting}
            className="update-btn"
          >
            {id ? (saving ? "שומר..." : "💾 שמירת שינויים") : ""}
          </button>
          {id && <button onClick={handleDeleteLeague} disabled={saving || deleting} className="delete-btn">
            {deleting ? "מוחק..." : "🗑 מחק ליגה"}
          </button>}
          <button onClick={() => navigate("/leagues")}>↩ חזור</button>
        </div>
      </div>
    </div>
  );
}

export default EditLeague;
